import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { Link } from 'foundations-components/transitional/components/Link';
import styled, { isCanvasTheme, isTrellisTheme } from 'foundations-theming/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const InputStyles = styled.div.withConfig({
  displayName: "TextInputstyles__InputStyles",
  componentId: "sc-1c6tlc2-0"
})(["display:inline-block;position:relative;vertical-align:left;border-color:white !important;background-color:white !important;width:100%;input{padding-top:14px !important;padding-bottom:18px !important;", " ", "}.Country,[data-selenium-id='country'],input{border-radius:0px !important;", " border:2px solid;border-left:none !important;border-right:none !important;border-top:none !important;", " ", " ", " ", "}.Country,[data-selenium-id='country']{margin-bottom:20px;}div[data-selenium-id='country']:hover{box-shadow:none !important;", " background:white;}div[aria-expanded='true']{", "}input[aria-invalid='true']{", " ", "}input:focus{&:focus{outline:none !important;border-color:#fff;box-shadow:none;", "}", "}input[aria-invalid='true'],input[aria-invalid='true']:focus{box-shadow:none !important;}"], props => props.industryStyle && isCanvasTheme(props.theme) && `
      margin-bottom: -3px;
    `, props => props.inputFontSize && `
      font-size: ${props.inputFontSize}px;
    `, props => isCanvasTheme(props.theme) ? `border-bottom-color: ${props.theme.color['border-accent-blue-default']} !important;` : `border-bottom-color: ${props.theme.color['border-core-default']} !important;`, props => props.success && `
      border-bottom-color: ${props.theme.color['fill-accent-green-hover']} !important;
    `, props => props.error && isCanvasTheme(props.theme) && `
      border-bottom-color: #bf2434 !important;
    `, props => props.error && isTrellisTheme(props.theme) && `
      border-bottom-color: ${props.theme.color['border-alert-default']} !important;
    `, props => props.disabled && `
      background-color: ${props.theme.color['fill-accent-neutral-subtle-alt']} !important;
      box-shadow: none !important;
      border-bottom-color: #cbd6e2 !important;
    `, props => isCanvasTheme(props.theme) ? `border-bottom-color: ${props.theme.color['border-accent-blue-default']} !important;` : `border-bottom-color: ${props.theme.color['border-core-default']} !important;`, props => isCanvasTheme(props.theme) ? `border-bottom-color: ${props.theme.color['border-accent-blue-default']} !important;` : `border-bottom-color: ${props.theme.color['border-core-default']} !important;`, props => isCanvasTheme(props.theme) && 'border-bottom-color: #bf2434 !important;', props => isTrellisTheme(props.theme) && `border-bottom-color: ${props.theme.color['border-alert-default']} !important;`, props => props.industryStyle && `
        border-bottom-color: ${isCanvasTheme(props.theme) ? props.theme.color['border-accent-blue-default'] : props.theme.color['border-core-default']} !important;
        ${props.success && `
          border-bottom-color: ${props.theme.color['fill-accent-green-hover']} !important;
        `}
        ${props.error && isCanvasTheme(props.theme) && `
          border-bottom-color: #bf2434 !important;
        `}
        ${props.error && isTrellisTheme(props.theme) && `
          border-bottom-color: ${props.theme.color['border-alert-default']} !important;
        `}
      `, props => props.industryStyle && `
        border-bottom-color: ${isCanvasTheme(props.theme) ? props.theme.color['border-accent-blue-default'] : props.theme.color['border-core-default']} !important;
        ${props.success && `
          border-bottom-color: ${props.theme.color['fill-accent-green-hover']} !important;
        `}
        ${props.error && isCanvasTheme(props.theme) && `
          border-bottom-color: #bf2434 !important;
        `}
        ${props.error && isTrellisTheme(props.theme) && `
          border-bottom-color: ${props.theme.color['border-alert-default']} !important;
        `}
      `);

/**
 * This component is adapted to not rely on the style overrides from typeahead.scss which
 * modify UIComponents internal classnames.
 *
 * Long-term this component will replace the InputStyles component once all occurrences of
 * InputStyles are removed from the codebase.
 */
export const MigratedInputStyles = styled(InputStyles).withConfig({
  displayName: "TextInputstyles__MigratedInputStyles",
  componentId: "sc-1c6tlc2-1"
})(["input{border:1px solid #fff;background-color:#fff;text-align:left;font-size:22px;padding-left:0px;border-radius:0px;", " &:focus{outline:none !important;border-color:#fff;box-shadow:none;}&:hover{border-color:#fff;box-shadow:none;}&:disabled{background-color:#fff;border:1px solid #fff;}}.Country,input,&& .Country:focus,&& input:focus,&& [id^='FormControl']:focus{outline:none !important;border-color:#fff !important;box-shadow:none !important;", " border:2px solid;border-left:none !important;border-right:none !important;border-top:none !important;", " ", " ", " ", "}"], props => props.inputFontSize && `
      font-size: ${props.inputFontSize}px;
    `, props => isCanvasTheme(props.theme) ? `border-bottom-color: ${props.theme.color['border-info-default']} !important;` : `border-bottom-color: ${props.theme.color['border-core-default']} !important;`, props => props.success && `
      border-bottom-color: ${props.theme.color['border-positive-default']} !important;
    `, props => props.error && isCanvasTheme(props.theme) && `
      border-bottom-color: #bf2434 !important;
    `, props => props.error && isTrellisTheme(props.theme) && `
      border-bottom-color: ${props.theme.color['border-alert-default']} !important;
    `, props => props.disabled && `
      background-color: ${props.theme.color['fill-field-disabled']} !important;
      box-shadow: none !important;
      border-bottom-color: #cbd6e2 !important;
    `);
const StyledLinkText = styled.span.withConfig({
  displayName: "TextInputstyles__StyledLinkText",
  componentId: "sc-1c6tlc2-2"
})(["", ";"], props => isCanvasTheme(props.theme) && 'color: #0b8484');
export const StyledUILink = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Link, Object.assign({}, props, {
    children: /*#__PURE__*/_jsx(StyledLinkText, {
      children: children
    })
  }));
};
export const StyledFormattedMessage = styled(FormattedMessage).withConfig({
  displayName: "TextInputstyles__StyledFormattedMessage",
  componentId: "sc-1c6tlc2-3"
})(["", ";"], props => isCanvasTheme(props.theme) && 'color: #0b8484 !important');
export const SidePanelTypeaheadInputStyles = styled.div.withConfig({
  displayName: "TextInputstyles__SidePanelTypeaheadInputStyles",
  componentId: "sc-1c6tlc2-4"
})(({
  theme,
  success,
  error
}) => {
  const borderColor = (() => {
    if (success) return theme.color['border-positive-default'];
    if (error) return theme.color['border-alert-default'];
    return theme.color['border-core-default'];
  })();
  return {
    display: 'inline-block',
    position: 'relative',
    verticalAlign: 'left',
    borderColor: 'white !important',
    backgroundColor: 'white !important',
    width: '360px',
    '[data-selenium="industry"], [data-selenium="jobrole"]': {
      backgroundColor: theme.color['fill-field-default'],
      border: `${theme.borderWidth['100']} solid ${borderColor}`,
      borderRadius: theme.borderRadius['100'],
      color: theme.color['text-core-default'],
      display: 'block',
      fontSize: theme.typography['body-200'].fontSize,
      height: '40px',
      lineHeight: theme.typography['body-200'].lineHeight,
      letterSpacing: theme.typography['body-200'].letterSpacing,
      paddingInline: theme.space['200'],
      paddingBlock: theme.space['200'],
      transition: 'all 150ms ease-out',
      verticalAlign: 'middle',
      '&:focus': {
        borderColor: 'transparent !important',
        outline: `${theme.borderWidth['200']} solid ${theme.color['border-info-default']} !important`,
        outlineOffset: `calc(${theme.borderWidth['200']} * -1)`,
        boxShadow: `inset 0 0 0 ${theme.borderWidth['200']} ${theme.color['border-core-on-fill-default']} !important`
      },
      '&:hover': {
        border: `${theme.borderWidth['100']} solid ${borderColor}`
      }
    }
  };
});